import "core-js/modules/es.error.cause.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.every.js";
import "core-js/modules/es.iterator.filter.js";
import "core-js/modules/es.iterator.find.js";
import "core-js/modules/es.iterator.flat-map.js";
import "core-js/modules/es.iterator.for-each.js";
import "core-js/modules/es.iterator.map.js";
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, createStaticVNode as _createStaticVNode } from "vue";
const _hoisted_1 = {
  class: "market-overview"
};
const _hoisted_2 = {
  key: 0,
  class: "global-loading"
};
const _hoisted_3 = {
  class: "section"
};
const _hoisted_4 = {
  class: "section-header"
};
const _hoisted_5 = {
  class: "section-title-wrapper"
};
const _hoisted_6 = {
  class: "section-subtitle"
};
const _hoisted_7 = {
  class: "global-index-grid"
};
const _hoisted_8 = {
  class: "index-card-content"
};
const _hoisted_9 = {
  class: "index-header"
};
const _hoisted_10 = {
  class: "index-code"
};
const _hoisted_11 = {
  key: 0,
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  class: "w-3 h-3"
};
const _hoisted_12 = {
  key: 1,
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  class: "w-3 h-3"
};
const _hoisted_13 = {
  class: "index-name"
};
const _hoisted_14 = {
  class: "index-value"
};
const _hoisted_15 = {
  key: 0,
  class: "index-chart"
};
const _hoisted_16 = {
  viewBox: "0 0 240 56",
  preserveAspectRatio: "none"
};
const _hoisted_17 = ["id"];
const _hoisted_18 = ["stop-color"];
const _hoisted_19 = ["stop-color"];
const _hoisted_20 = ["d", "fill"];
const _hoisted_21 = ["d", "stroke"];
const _hoisted_22 = {
  key: 1,
  class: "index-not-available"
};
const _hoisted_23 = {
  class: "section"
};
const _hoisted_24 = {
  class: "metrics-grid"
};
const _hoisted_25 = {
  class: "metric-card"
};
const _hoisted_26 = {
  class: "metric-content"
};
const _hoisted_27 = {
  class: "metric-value"
};
const _hoisted_28 = {
  class: "metric-card"
};
const _hoisted_29 = {
  class: "metric-content"
};
const _hoisted_30 = {
  class: "metric-value"
};
const _hoisted_31 = {
  class: "up-value"
};
const _hoisted_32 = {
  class: "down-value"
};
const _hoisted_33 = {
  class: "metric-card"
};
const _hoisted_34 = {
  class: "metric-content"
};
const _hoisted_35 = {
  class: "metric-value temperature"
};
const _hoisted_36 = {
  class: "temperature-status"
};
const _hoisted_37 = {
  class: "metric-card"
};
const _hoisted_38 = {
  class: "metric-content"
};
const _hoisted_39 = {
  class: "capital-flows"
};
const _hoisted_40 = {
  class: "flow-value"
};
const _hoisted_41 = {
  class: "flow-value"
};
const _hoisted_42 = {
  class: "market-summary-row"
};
const _hoisted_43 = {
  class: "market-summary-card"
};
const _hoisted_44 = {
  class: "summary-content"
};
const _hoisted_45 = {
  class: "summary-left"
};
const _hoisted_46 = {
  class: "summary-middle"
};
const _hoisted_47 = {
  class: "summary-count up"
};
const _hoisted_48 = {
  class: "summary-chart"
};
const _hoisted_49 = {
  class: "summary-count down"
};
const _hoisted_50 = {
  class: "summary-right"
};
const _hoisted_51 = {
  class: "summary-item"
};
const _hoisted_52 = {
  class: "summary-item"
};
const _hoisted_53 = {
  class: "summary-value"
};
const _hoisted_54 = {
  class: "market-summary-card"
};
const _hoisted_55 = {
  class: "summary-content"
};
const _hoisted_56 = {
  class: "summary-left"
};
const _hoisted_57 = {
  class: "summary-middle"
};
const _hoisted_58 = {
  class: "summary-count up"
};
const _hoisted_59 = {
  class: "summary-chart"
};
const _hoisted_60 = {
  class: "summary-count down"
};
const _hoisted_61 = {
  class: "summary-right"
};
const _hoisted_62 = {
  class: "summary-item"
};
const _hoisted_63 = {
  class: "summary-item"
};
const _hoisted_64 = {
  class: "summary-value"
};
const _hoisted_65 = {
  class: "news-flash-section"
};
const _hoisted_66 = {
  class: "news-flash-header"
};
const _hoisted_67 = {
  class: "news-subtitle"
};
const _hoisted_68 = {
  class: "news-list"
};
const _hoisted_69 = {
  class: "news-time"
};
const _hoisted_70 = {
  class: "news-content"
};
const _hoisted_71 = {
  class: "news-source"
};
const _hoisted_72 = ["href"];
const _hoisted_73 = {
  key: 1,
  class: "news-text"
};
const _hoisted_74 = {
  key: 0,
  class: "news-item"
};
import { ref, computed, onMounted, onUnmounted } from 'vue';

// 全球指数（初始占位，挂载后由接口填充）
const API = '/server-api/dang-market';
export default {
  __name: 'Dahai',
  setup(__props) {
    const globalIndices = ref([{
      code: '000001.SH',
      name: '上证指数',
      value: '--',
      change: 0,
      chart: null,
      areaChart: null
    }, {
      code: '399001.SZ',
      name: '深证成指',
      value: '--',
      change: 0,
      chart: null,
      areaChart: null
    }, {
      code: '399006.SZ',
      name: '创业板指',
      value: '--',
      change: 0,
      chart: null,
      areaChart: null
    }, {
      code: '000688.SH',
      name: '科创50',
      value: '--',
      change: 0,
      chart: null,
      areaChart: null
    }, {
      code: '000905.SH',
      name: '中证500',
      value: '--',
      change: 0,
      chart: null,
      areaChart: null
    }, {
      code: '399303.SZ',
      name: '国证2000',
      value: '--',
      change: 0,
      chart: null,
      areaChart: null
    }]);

    // 总览（市场脉搏 + A股统计）/ 7x24 快讯
    const overview = ref(null);
    const aShareStats = ref(null); // 涨跌统计：A股（realtime.stats.cn）
    const hkConnect = ref(null); // 涨跌统计：港股通（realtime.stats.hk）
    const newsList = ref([]);
    const lastUpdated = ref('');
    const loading = ref(false);

    // 经本地代理透传 dang-invest.com 的市场接口（开发态走 vue.config devServer.before，生产走 Cloudflare 函数）
    const fmt = (n, d = 2) => n == null || isNaN(n) ? '--' : Number(n).toFixed(d);
    const fmtYi = yuan => yuan == null ? '--' : (yuan / 1e8).toFixed(1);
    function sourceLabel(s) {
      const m = {
        sina: '新浪',
        cls: '财联社',
        eastmoney: '东方财富',
        '10jqka': '同花顺',
        futu: '富途',
        wallstreetcn: '华尔街见闻',
        yicai: '第一财经'
      };
      return m[s] || s || '未知';
    }

    // 将 change_pct 序列绘制为 240x56 的 SVG 路径
    function buildSparkline(values) {
      if (!Array.isArray(values) || values.length < 2) return {
        chart: null,
        areaChart: null
      };
      const min = Math.min(...values);
      const max = Math.max(...values);
      const range = max - min || 1;
      const n = values.length;
      const W = 240;
      const H = 56;
      const pad = 4;
      const pts = values.map((v, i) => {
        const x = i / (n - 1) * W;
        const y = H - pad - (v - min) / range * (H - 2 * pad);
        return [x, y];
      });
      const line = pts.map((p, i) => `${i ? 'L' : 'M'} ${p[0].toFixed(2)} ${p[1].toFixed(2)}`).join(' ');
      const area = `M 0 ${H} ` + pts.map(p => `L ${p[0].toFixed(2)} ${p[1].toFixed(2)}`).join(' ') + ` L ${W} ${H} Z`;
      return {
        chart: line,
        areaChart: area
      };
    }
    async function getJSON(path) {
      const r = await fetch(`${API}/${path}`, {
        cache: 'no-store'
      });
      if (!r.ok) throw new Error(`HTTP ${r.status}`);
      return r.json();
    }

    // 腾讯指数兜底：当 dang-market 的指数 price 为 null（上游缓存陈旧）时，
    // 走 /server-api/index-quote 拉取腾讯行情快照 + 分时涨跌幅序列
    const QT_INDEX_CODES = ['sh000001', 'sz399001', 'sz399006', 'sh000688', 'sh000905', 'sz399303'];
    async function loadIndicesFallback() {
      const r = await fetch(`/server-api/index-quote?codes=${QT_INDEX_CODES.join(',')}&intraday=1`, {
        cache: 'no-store'
      });
      if (!r.ok) throw new Error(`HTTP ${r.status}`);
      const d = await r.json();
      // 腾讯代码 → EM 风格代码（sh000001 → 000001.SH）
      const items = (d.items || []).map(it => {
        const tc = it.tencentCode || '';
        const num = tc.replace(/^(sh|sz)/, '');
        const code = tc.startsWith('sh') ? `${num}.SH` : tc.startsWith('sz') ? `${num}.SZ` : tc;
        return {
          code,
          name: it.name,
          value: it.price == null ? '--' : Number(it.price).toLocaleString('zh-CN', {
            maximumFractionDigits: 2
          }),
          change: it.changePct == null ? 0 : Number(it.changePct),
          chart: null,
          areaChart: null
        };
      });
      if (!items.length) return;
      globalIndices.value = items;
      // 腾讯分时涨跌幅 → 迷你走势图（intraday 以腾讯代码为键）
      const intra = d.intraday || {};
      items.forEach(idx => {
        const t = intra[qtCodeOf(idx.code)];
        const series = t && t.changePcts;
        if (series && series.length) {
          const sp = buildSparkline(series);
          idx.chart = sp.chart;
          idx.areaChart = sp.areaChart;
        }
      });
    }
    // EM 风格指数代码（000001.SH）→ 腾讯代码（sh000001）
    function qtCodeOf(code) {
      if (!code) return '';
      const [num, suf] = String(code).split('.');
      return (suf === 'SH' ? 'sh' : 'sz') + num;
    }
    async function loadAll() {
      loading.value = true;
      try {
        // 四路并行（原先串行 + 每 200ms 延迟，导致整页加载慢）
        const pRealtime = getJSON('dashboard/realtime').then(rt => {
          // 涨跌统计（A股 / 港股通）在 rt.stats.cn / rt.stats.hk
          const stats = rt && rt.stats || {};
          aShareStats.value = stats.cn || null;
          hkConnect.value = stats.hk || null;
          const groups = rt && rt.realtime && rt.realtime.groups || [];
          const items = groups.filter(g => g.id === 'indices-cn').flatMap(g => (g.items || []).map(it => ({
            code: it.symbol,
            name: it.name,
            value: it.price == null ? '--' : Number(it.price).toLocaleString('zh-CN', {
              maximumFractionDigits: 2
            }),
            change: it.changePct == null ? 0 : Number(it.changePct),
            chart: null,
            areaChart: null
          })));
          return items;
        }).catch(e => {
          console.warn('[Dahai] realtime', e);
          return [];
        });
        const pIntraday = getJSON('dashboard/intraday?groups=indices-cn').catch(e => {
          console.warn('[Dahai] intraday', e);
          return null;
        });
        const pOverview = getJSON('overview').then(ov => {
          overview.value = ov && ov.data || {};
        }).catch(e => console.warn('[Dahai] overview', e));
        const pNews = getJSON('news?limit=60&offset=0').then(nw => {
          newsList.value = (nw.data || []).map(d => ({
            time: (d.published_at || '').slice(11, 16) || '--',
            source: sourceLabel(d.source),
            text: d.content || d.title || '',
            url: d.url || ''
          }));
        }).catch(e => console.warn('[Dahai] news', e));
        const [emItems, emIntraday] = await Promise.all([pRealtime, pIntraday]);
        // 指数：上游有效则用上游；price 全为 null（上游缓存陈旧）则走腾讯兜底
        const hasEmPrices = emItems.length && emItems.every(it => it.value !== '--');
        if (hasEmPrices) {
          globalIndices.value = emItems;
        } else {
          try {
            await loadIndicesFallback();
          } catch (e) {
            console.warn('[Dahai] index-quote fallback', e);
          }
        }
        // 分时走势图（上游 intraday 有效时优先）
        if (emIntraday) {
          const gm = emIntraday.groups || {};
          Object.values(gm).forEach(g => {
            (g.items || []).forEach(it => {
              const series = (it.points || []).map(p => p.change_pct);
              const sp = buildSparkline(series);
              const t = globalIndices.value.find(x => x.code === it.symbol);
              if (t) {
                t.chart = sp.chart;
                t.areaChart = sp.areaChart;
              }
            });
          });
        }
        await Promise.all([pOverview, pNews]);
        lastUpdated.value = new Date().toLocaleTimeString('zh-CN', {
          hour: '2-digit',
          minute: '2-digit',
          second: '2-digit'
        });
      } finally {
        loading.value = false;
      }
    }

    // 涨跌统计卡片（A股 / 港股通）统一由 realtime.stats.{cn,hk} 提供
    function buildSummary(s) {
      var _s$up, _s$down, _s$total;
      if (!s) return {
        up: '--',
        down: '--',
        avg: null,
        total: '--',
        upPct: 50
      };
      const up = (_s$up = s.up) !== null && _s$up !== void 0 ? _s$up : 0;
      const down = (_s$down = s.down) !== null && _s$down !== void 0 ? _s$down : 0;
      const denom = up + down || 1;
      return {
        up,
        down,
        avg: s.avg == null ? null : Number(s.avg),
        total: (_s$total = s.total) !== null && _s$total !== void 0 ? _s$total : '--',
        upPct: up / denom * 100
      };
    }
    const aShare = computed(() => buildSummary(aShareStats.value));
    const hk = computed(() => buildSummary(hkConnect.value));
    let timer = null;
    onMounted(() => {
      loadAll();
      timer = setInterval(loadAll, 60000);
    });
    onUnmounted(() => {
      if (timer) clearInterval(timer);
    });
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", _hoisted_1, [loading.value ? (_openBlock(), _createElementBlock("div", _hoisted_2, [...(_cache[0] || (_cache[0] = [_createElementVNode("span", {
        class: "spinner"
      }, null, -1), _createTextVNode("加载中…", -1)]))])) : _createCommentVNode("", true), _createElementVNode("section", _hoisted_3, [_createElementVNode("div", _hoisted_4, [_createElementVNode("div", _hoisted_5, [_cache[1] || (_cache[1] = _createElementVNode("h2", {
        class: "section-title"
      }, "全球指数", -1)), _createElementVNode("span", _hoisted_6, "A股港股，一览全球行情 · 更新于 " + _toDisplayString(lastUpdated.value || '—'), 1)])]), _createElementVNode("div", _hoisted_7, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(globalIndices.value, index => {
        return _openBlock(), _createElementBlock("div", {
          class: "index-card",
          key: index.code
        }, [_createElementVNode("div", _hoisted_8, [_createElementVNode("div", _hoisted_9, [_createElementVNode("span", _hoisted_10, _toDisplayString(index.code), 1), index.change !== 0 ? (_openBlock(), _createElementBlock("span", {
          key: 0,
          class: _normalizeClass(['index-change-badge', index.change >= 0 ? 'up' : 'down'])
        }, [index.change >= 0 ? (_openBlock(), _createElementBlock("svg", _hoisted_11, [...(_cache[2] || (_cache[2] = [_createElementVNode("path", {
          d: "m5 12 7-7 7 7"
        }, null, -1), _createElementVNode("path", {
          d: "M12 19V5"
        }, null, -1)]))])) : (_openBlock(), _createElementBlock("svg", _hoisted_12, [...(_cache[3] || (_cache[3] = [_createElementVNode("path", {
          d: "m19 12-7 7-7-7"
        }, null, -1), _createElementVNode("path", {
          d: "M12 5v14"
        }, null, -1)]))])), _createTextVNode(" " + _toDisplayString(index.change >= 0 ? '+' : '') + _toDisplayString(index.change) + "% ", 1)], 2)) : _createCommentVNode("", true)]), _createElementVNode("div", _hoisted_13, _toDisplayString(index.name), 1), _createElementVNode("div", _hoisted_14, _toDisplayString(index.value), 1), index.chart ? (_openBlock(), _createElementBlock("div", _hoisted_15, [(_openBlock(), _createElementBlock("svg", _hoisted_16, [_createElementVNode("defs", null, [_createElementVNode("linearGradient", {
          id: 'gradient-' + index.code,
          x1: "0%",
          y1: "0%",
          x2: "0%",
          y2: "100%"
        }, [_createElementVNode("stop", {
          offset: "0%",
          "stop-color": index.change >= 0 ? 'rgba(239, 68, 68, 0.35)' : 'rgba(34, 197, 94, 0.35)'
        }, null, 8, _hoisted_18), _createElementVNode("stop", {
          offset: "100%",
          "stop-color": index.change >= 0 ? 'rgba(239, 68, 68, 0)' : 'rgba(34, 197, 94, 0)'
        }, null, 8, _hoisted_19)], 8, _hoisted_17)]), _createElementVNode("path", {
          d: index.areaChart,
          fill: 'url(#gradient-' + index.code + ')'
        }, null, 8, _hoisted_20), _createElementVNode("path", {
          d: index.chart,
          fill: "none",
          stroke: index.change >= 0 ? '#ef4444' : '#22c55e',
          "stroke-width": "1.8",
          "stroke-linejoin": "round",
          "stroke-linecap": "round"
        }, null, 8, _hoisted_21)]))])) : (_openBlock(), _createElementBlock("div", _hoisted_22, "日内暂未接入"))])]);
      }), 128))])]), _createElementVNode("section", _hoisted_23, [_cache[21] || (_cache[21] = _createElementVNode("div", {
        class: "section-header"
      }, [_createElementVNode("h2", {
        class: "section-title"
      }, "市场脉搏"), _createElementVNode("span", {
        class: "section-subtitle"
      }, "A股港股通涨跌统计，宽基ETF实时行情")], -1)), _createElementVNode("div", _hoisted_24, [_createElementVNode("div", _hoisted_25, [_createElementVNode("div", _hoisted_26, [_cache[4] || (_cache[4] = _createStaticVNode("<div class=\"metric-header\" data-v-9bb826fe><svg xmlns=\"http://www.w3.org/2000/svg\" width=\"24\" height=\"24\" viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\" class=\"metric-icon text-blue-500\" data-v-9bb826fe><path d=\"M16 7h6v6\" data-v-9bb826fe></path><path d=\"m22 7-8.5 8.5-5-5L2 17\" data-v-9bb826fe></path></svg><span class=\"metric-label\" data-v-9bb826fe>两市成交额（亿元）</span></div>", 1)), _createElementVNode("div", _hoisted_27, _toDisplayString(overview.value ? fmtYi(overview.value.totalTurnoverYuan) : '--'), 1)])]), _createElementVNode("div", _hoisted_28, [_createElementVNode("div", _hoisted_29, [_cache[6] || (_cache[6] = _createElementVNode("div", {
        class: "metric-header"
      }, [_createElementVNode("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: "currentColor",
        "stroke-width": "2",
        "stroke-linecap": "round",
        "stroke-linejoin": "round",
        class: "metric-icon text-rose-500"
      }, [_createElementVNode("path", {
        d: "M12 3q1 4 4 6.5t3 5.5a1 1 0 0 1-14 0 5 5 0 0 1 1-3 1 1 0 0 0 5 0c0-2-1.5-3-1.5-5q0-2 2.5-4"
      })]), _createElementVNode("span", {
        class: "metric-label"
      }, "涨停 / 跌停")], -1)), _createElementVNode("div", _hoisted_30, [_createElementVNode("span", _hoisted_31, _toDisplayString(overview.value ? overview.value.limitUpCount : '--'), 1), _cache[5] || (_cache[5] = _createElementVNode("span", {
        class: "divider"
      }, "/", -1)), _createElementVNode("span", _hoisted_32, _toDisplayString(overview.value ? overview.value.limitDownCount : '--'), 1)])])]), _createElementVNode("div", _hoisted_33, [_createElementVNode("div", _hoisted_34, [_cache[7] || (_cache[7] = _createStaticVNode("<div class=\"metric-header\" data-v-9bb826fe><svg xmlns=\"http://www.w3.org/2000/svg\" width=\"24\" height=\"24\" viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\" class=\"metric-icon text-amber-500\" data-v-9bb826fe><path d=\"m12 14 4-4\" data-v-9bb826fe></path><path d=\"M3.34 19a10 10 0 1 1 17.32 0\" data-v-9bb826fe></path></svg><span class=\"metric-label\" data-v-9bb826fe>情绪温度</span></div>", 1)), _createElementVNode("div", _hoisted_35, _toDisplayString(overview.value ? overview.value.marketTemperature : '--'), 1), _createElementVNode("div", _hoisted_36, _toDisplayString(overview.value ? overview.value.sentimentLabel : '—'), 1)])]), _createElementVNode("div", _hoisted_37, [_createElementVNode("div", _hoisted_38, [_cache[10] || (_cache[10] = _createElementVNode("div", {
        class: "metric-header"
      }, [_createElementVNode("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: "currentColor",
        "stroke-width": "2",
        "stroke-linecap": "round",
        "stroke-linejoin": "round",
        class: "metric-icon text-teal-500"
      }, [_createElementVNode("path", {
        d: "M22 12h-2.48a2 2 0 0 0-1.93 1.46l-2.35 8.36a.25.25 0 0 1-.48 0L9.24 2.18a.25.25 0 0 0-.48 0l-2.35 8.36A2 2 0 0 1 4.49 12H2"
      })]), _createElementVNode("span", {
        class: "metric-label"
      }, "资金净流（亿元）")], -1)), _createElementVNode("div", _hoisted_39, [_cache[8] || (_cache[8] = _createElementVNode("span", {
        class: "flow-label"
      }, "北向", -1)), _createElementVNode("span", _hoisted_40, _toDisplayString(overview.value && overview.value.northInflowYuan != null ? fmt(overview.value.northInflowYuan / 1e8) : '--'), 1), _cache[9] || (_cache[9] = _createElementVNode("span", {
        class: "flow-label"
      }, "主力", -1)), _createElementVNode("span", _hoisted_41, _toDisplayString(overview.value && overview.value.mainInflowYuan != null ? fmt(overview.value.mainInflowYuan / 1e8) : '--'), 1)])])])]), _createElementVNode("div", _hoisted_42, [_createElementVNode("div", _hoisted_43, [_createElementVNode("div", _hoisted_44, [_createElementVNode("div", _hoisted_45, [_cache[11] || (_cache[11] = _createElementVNode("span", {
        class: "summary-market"
      }, "A股", -1)), _createElementVNode("span", {
        class: _normalizeClass(['summary-badge', aShare.value.avg == null ? '' : aShare.value.avg >= 0 ? 'strong' : 'weak'])
      }, _toDisplayString(aShare.value.avg == null ? '—' : aShare.value.avg >= 0 ? '偏多' : '偏空'), 3)]), _createElementVNode("div", _hoisted_46, [_createElementVNode("span", _hoisted_47, _toDisplayString(aShare.value.up) + " 涨", 1), _createElementVNode("div", _hoisted_48, [_createElementVNode("div", {
        class: "summary-bar red",
        style: _normalizeStyle({
          width: aShare.value.upPct + '%'
        })
      }, null, 4), _createElementVNode("div", {
        class: "summary-bar green",
        style: _normalizeStyle({
          width: 100 - aShare.value.upPct + '%'
        })
      }, null, 4)]), _createElementVNode("span", _hoisted_49, _toDisplayString(aShare.value.down) + " 跌", 1)]), _createElementVNode("div", _hoisted_50, [_createElementVNode("div", _hoisted_51, [_cache[12] || (_cache[12] = _createElementVNode("span", {
        class: "summary-label"
      }, "平均涨跌", -1)), _createElementVNode("span", {
        class: _normalizeClass(['summary-value', aShare.value.avg == null ? '' : aShare.value.avg >= 0 ? 'up' : 'down'])
      }, _toDisplayString(aShare.value.avg == null ? '--' : (aShare.value.avg >= 0 ? '+' : '') + aShare.value.avg.toFixed(2) + '%'), 3)]), _createElementVNode("div", _hoisted_52, [_cache[13] || (_cache[13] = _createElementVNode("span", {
        class: "summary-label"
      }, "总数", -1)), _createElementVNode("span", _hoisted_53, _toDisplayString(aShare.value.total), 1)]), _cache[14] || (_cache[14] = _createElementVNode("span", {
        class: "summary-refresh"
      }, "每60秒刷新", -1))])])]), _createElementVNode("div", _hoisted_54, [_createElementVNode("div", _hoisted_55, [_createElementVNode("div", _hoisted_56, [_cache[15] || (_cache[15] = _createElementVNode("span", {
        class: "summary-market"
      }, "港股通", -1)), _createElementVNode("span", {
        class: _normalizeClass(['summary-badge', hk.value.avg == null ? '' : hk.value.avg >= 0 ? 'strong' : 'weak'])
      }, _toDisplayString(hk.value.avg == null ? '—' : hk.value.avg >= 0 ? '偏多' : '偏空'), 3)]), _createElementVNode("div", _hoisted_57, [_createElementVNode("span", _hoisted_58, _toDisplayString(hk.value.up) + " 涨", 1), _createElementVNode("div", _hoisted_59, [_createElementVNode("div", {
        class: "summary-bar red",
        style: _normalizeStyle({
          width: hk.value.upPct + '%'
        })
      }, null, 4), _createElementVNode("div", {
        class: "summary-bar green",
        style: _normalizeStyle({
          width: 100 - hk.value.upPct + '%'
        })
      }, null, 4)]), _createElementVNode("span", _hoisted_60, _toDisplayString(hk.value.down) + " 跌", 1)]), _createElementVNode("div", _hoisted_61, [_createElementVNode("div", _hoisted_62, [_cache[16] || (_cache[16] = _createElementVNode("span", {
        class: "summary-label"
      }, "平均涨跌", -1)), _createElementVNode("span", {
        class: _normalizeClass(['summary-value', hk.value.avg == null ? '' : hk.value.avg >= 0 ? 'up' : 'down'])
      }, _toDisplayString(hk.value.avg == null ? '--' : (hk.value.avg >= 0 ? '+' : '') + hk.value.avg.toFixed(2) + '%'), 3)]), _createElementVNode("div", _hoisted_63, [_cache[17] || (_cache[17] = _createElementVNode("span", {
        class: "summary-label"
      }, "总数", -1)), _createElementVNode("span", _hoisted_64, _toDisplayString(hk.value.total), 1)]), _cache[18] || (_cache[18] = _createElementVNode("span", {
        class: "summary-refresh"
      }, "每60秒刷新", -1))])])])]), _createElementVNode("section", _hoisted_65, [_createElementVNode("div", _hoisted_66, [_cache[19] || (_cache[19] = _createElementVNode("h2", {
        class: "news-title"
      }, "7x24快讯", -1)), _createElementVNode("span", _hoisted_67, "近24小时 · 已加载 " + _toDisplayString(newsList.value.length) + " 条", 1)]), _createElementVNode("div", _hoisted_68, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(newsList.value, (n, i) => {
        return _openBlock(), _createElementBlock("div", {
          class: "news-item",
          key: i
        }, [_createElementVNode("div", _hoisted_69, _toDisplayString(n.time), 1), _createElementVNode("div", _hoisted_70, [_createElementVNode("span", _hoisted_71, _toDisplayString(n.source), 1), n.url ? (_openBlock(), _createElementBlock("a", {
          key: 0,
          href: n.url,
          target: "_blank",
          rel: "noreferrer noopener",
          class: "news-title-link"
        }, _toDisplayString(n.text), 9, _hoisted_72)) : (_openBlock(), _createElementBlock("span", _hoisted_73, _toDisplayString(n.text), 1))])]);
      }), 128)), !newsList.value.length ? (_openBlock(), _createElementBlock("div", _hoisted_74, [...(_cache[20] || (_cache[20] = [_createElementVNode("div", {
        class: "news-time"
      }, "--", -1), _createElementVNode("div", {
        class: "news-content"
      }, [_createElementVNode("span", {
        class: "news-text"
      }, "快讯加载中…")], -1)]))])) : _createCommentVNode("", true)])])])]);
    };
  }
};